module.exports = __webpack_public_path__ + "f1f0ff55907f73897f038ed13cc81b9f.mp4";